// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2UdrV","info":"Note_info__QRNOp","note":"Note_note__2Rsg_","actions":"Note_actions__JSYBc"};